import { takeLatest, put, call } from 'redux-saga/effects';
import { MissionsTypes, MissionsAction, Mission, Skill, Stage } from '../types';
import { saveMission, getList, saveStage, updateRewards } from '../actions';
import { getMissionsFirebase, saveStageFirebase, saveMissionFirebase, updateRewardsFirebase } from '../repository';

export function* requestGetListSaga(): unknown {
    try {
        const missions = yield call(getMissionsFirebase);
        yield put(getList(missions));
    } catch (err: unknown) {
        yield put(getList([]));
    }
}

export function* requestSaveMissionSaga(
    props: MissionsAction<{
        mission: Mission;
        skills: Skill[];
        isNewMission: boolean;
        isSomeSurveyExit: boolean;
    }>,
): unknown {
    try {
        const mission = yield call(
            saveMissionFirebase,
            props.payload.mission,
            props.payload.skills,
            props.payload.isNewMission,
            props.payload.isSomeSurveyExit,
        );
        yield put(saveMission(mission));
    } catch (err: unknown) {
        yield put(saveMission());
    }
}

export function* requestSaveStageSaga(props: MissionsAction<{ stage: Stage; missionId: string }>): unknown {
    try {
        const stage = yield call(saveStageFirebase, props.payload.stage, props.payload.missionId);
        yield put(saveStage(props.payload.missionId, stage));
    } catch (err: unknown) {
        yield put(saveStage(props.payload.missionId));
    }
}

export function* requestUpdateRewardsSaga(props: MissionsAction<{ rewards: string[]; missionId: string }>): unknown {
    try {
        const rewards = yield call(updateRewardsFirebase, props.payload.rewards, props.payload.missionId);
        yield put(updateRewards(props.payload.missionId, rewards));
    } catch (err: unknown) {
        yield put(updateRewards(props.payload.missionId));
    }
}

export default [
    takeLatest(MissionsTypes.REQUEST_GET_LIST, requestGetListSaga),
    takeLatest(MissionsTypes.REQUEST_SAVE_MISSION, requestSaveMissionSaga),
    takeLatest(MissionsTypes.REQUEST_SAVE_STAGE, requestSaveStageSaga),
    takeLatest(MissionsTypes.REQUEST_UPDATE_REWARDS, requestUpdateRewardsSaga),
];
